import CoachAccreditationsRow from './coach-accreditations-row'

export { coachAccreditationsRowHasContent } from './coach-accreditations-row'
export default CoachAccreditationsRow
